import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
import { Stack } from "@mui/material";
import { NO_COLOR } from "../../constants.js";
import { useColorPicker } from "../../hooks/useColorPicker.js";
import { Footer } from "../Footer.js";
import { Placeholder } from "../Placeholder/Placeholder.js";
import { Swatch } from "../Swatch/Swatch.js";
import { CustomColorGroups } from "./components/CustomColorGroups/CustomColorGroups.js";
import { Grid } from "./components/Grid/Grid.js";
import { usePaletteMaxHeight } from "./hooks/usePaletteMaxHeight.js";
function Palette(props) {
  const { palette: rawPalette, testId = "ColorPicker--Palette" } = props;
  const {
    selection,
    onChange,
    customColors,
    onAddColor,
    placeholderMode,
    swatchesPerRow,
    goToAddColorToPalette,
    localeText,
    autoCommit,
    onCommit,
    onCancel,
    allowNoColor,
    maxRowsBeforeScrolling,
    swatchSize,
    swatchesGap
  } = useColorPicker();
  const noColorPaletteItem = {
    color: NO_COLOR,
    label: localeText.noColorLabel
  };
  const palette = allowNoColor ? [noColorPaletteItem, ...rawPalette] : rawPalette;
  const canAddColor = !!onAddColor && customColors === "add-inline";
  const lastRowChipsCount = palette.length % swatchesPerRow;
  const placeholdersCount = canAddColor ? placeholderMode === "fill-row" ? swatchesPerRow - lastRowChipsCount : 1 : 0;
  const placeholderDisabled = false;
  const maxHeight = usePaletteMaxHeight({
    maxRowsBeforeScrolling,
    palette,
    swatchesGap,
    swatchesPerRow,
    swatchSize
  });
  const renderCustomColorGroups = customColors !== "none" && customColors !== "add-inline";
  return /* @__PURE__ */ jsxs(Stack, { "data-testid": testId, gap: 2, children: [
    /* @__PURE__ */ jsxs(Stack, { gap: 1, children: [
      /* @__PURE__ */ jsxs(Grid, { maxHeight, testId: "Palette--Grid", children: [
        palette.map((color) => /* @__PURE__ */ createElement(
          Swatch,
          {
            ...color,
            key: color.color,
            localeText,
            onSelect: onChange,
            selected: selection.has(color.color),
            swatchSize
          }
        )),
        Array.from({ length: placeholdersCount }).map((_, idx) => /* @__PURE__ */ jsx(
          Placeholder,
          {
            disabled: placeholderDisabled,
            onClick: goToAddColorToPalette,
            swatchSize,
            tooltip: placeholderDisabled ? localeText.addColorDisabledTooltip : localeText.addColorTooltip
          },
          idx
        ))
      ] }),
      renderCustomColorGroups && /* @__PURE__ */ jsx(CustomColorGroups, { customColors })
    ] }),
    !autoCommit && /* @__PURE__ */ jsx(Footer, { onCancel, onCommit })
  ] });
}
export {
  Palette
};
//# sourceMappingURL=Palette.js.map
